import * as React from 'react';
import * as c3 from 'c3';

interface Props extends React.HTMLProps<HTMLDivElement> {
	config: c3.ChartConfiguration;
}

export default class Chart extends React.Component<Props, EmptyState> {

	private chart: Nullable<c3.ChartAPI> = null;
	private ref = React.createRef<HTMLDivElement>();

	componentDidMount() {
		this.destroyChart();
		this.generateChart(this.props);
	}

	componentWillUnmount() {
		this.destroyChart();
	}

	componentDidUpdate() {
		this.destroyChart();
		this.generateChart(this.props);
	}

	private generateChart(props: Props): void {

		this.chart = c3.generate({
			...props.config,
			bindto: this.ref.current!
		});
	}

	private destroyChart(): void {
		try {
			if (this.chart) {
				this.chart.destroy();
				this.chart = null;
			}
		}
		catch (error) {
			throw new Error('Internal C3 error: ' + error);
		}
	}

	render() {
		const { config, ...divProps } = this.props;
		return <div ref={this.ref} {...divProps} />;
	}
}
